import { AppState } from 'web/store'
import { CourseID } from 'common/types/courses'

export const getCourseModules = (courseId: CourseID, preview?: boolean) => (
  state: AppState
) => {
  if (preview) return null
  return state.modules.data.byCourse[courseId]
}
